/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a solvent's boiling point at reduced pressure (vacuum distillation).`)
};

const es_bp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encuentra el punto de ebullición de un disolvente a presión reducida (destilación al vacío).`)
};

const de_bp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ermitteln Sie den Siedepunkt eines Lösungsmittels bei reduziertem Druck (Vakuumdestillation).`)
};

const nl_bp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bepaal het kookpunt van een oplosmiddel bij verlaagde druk (vacuümdestillatie).`)
};

const fr_bp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouvez le point d'ébullition d'un solvant à pression réduite (distillation sous vide).`)
};

const it_bp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trova il punto di ebollizione di un solvente a pressione ridotta (distillazione sottovuoto).`)
};

const pt_br2_bp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre o ponto de ebulição de um solvente sob pressão reduzida (destilação a vácuo).`)
};

const pt_bp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Determine o ponto de ebulição de um solvente a pressão reduzida (destilação a vácuo).`)
};

const ja_bp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`減圧下(減圧蒸留)での溶媒の沸点を求めます。`)
};

const zh_bp_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`求解溶剂在减压（真空蒸馏）下的沸点。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_tool_description", locale)
	if (locale === "en") return en_bp_tool_description(inputs)
	if (locale === "es") return es_bp_tool_description(inputs)
	if (locale === "de") return de_bp_tool_description(inputs)
	if (locale === "nl") return nl_bp_tool_description(inputs)
	if (locale === "fr") return fr_bp_tool_description(inputs)
	if (locale === "it") return it_bp_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_bp_tool_description(inputs)
	if (locale === "pt") return pt_bp_tool_description(inputs)
	if (locale === "ja") return ja_bp_tool_description(inputs)
	return zh_bp_tool_description(inputs)
};